import environment from "../environment";

export class AppConstants {
  static readonly CODE_COOKIE = "code";
  static readonly CSRF_COOKIE = "csrf";
  static readonly TOKEN_ID_COOKIE = "token-id";
  static readonly ACCESS_TOKEN_COOKIE = "access-token";
  static readonly REFRESH_TOKEN_COOKIE = "refresh-token";

  static readonly TOKEN_ID = "tokenId";
  static readonly DATA_TYPE_JSON = "json";

  static readonly TOAST_TYPE_ERROR = "error";
  static readonly TOAST_TYPE_SUCCESS = "success";

  static readonly DEFAULT_INACTIVITY_LOGOUT_TIME =
    environment.inactivityAutoLogoutTime;
  static readonly DEFAULT_INACTIVITY_WARNING_TIME =
    environment.inactivityWarningTime;

  static readonly DEFAULT_PAGE = 1;
  static DEFAULT_PAGE_SIZE = 5;
  static readonly MAXIMUM_PAGE_SIZE = 10000;
  static DEFAULT_PAGE_SIZES = [5, 10, 20];
  static DEFAULT_MIGRATION_LOG_REFRESH_INTERVAL = 10000;
  static readonly MODULE_LIST_DEFAULT_PAGE_SIZE = 5;

  static readonly DEFAULT_TEXT_MAX_LENGTH = 255;

  static readonly DEFAULT_TOAST_SUCCESS_TTL = 3000;
  static readonly DEFAULT_TOAST_ERROR_TTL = 6000;

  static readonly HEADER_X_USERNAME = "X-Username";
  static readonly HEADER_X_PASSWORD = "X-Password";
  static readonly HEADER_CONTENT_TYPE = "Content-Type";
  static readonly HEADER_ACCEPT = "Accept";
  static readonly HEADER_X_LOCALE = "X-Locale";

  static readonly GCS_UPLOAD_ACTION = "UPLOAD";
  static readonly GCS_UPLOAD_DOWNLOAD = "DOWNLOAD";
  static readonly GCS_MAX_EXPIRATION_TIME = 1440;
  static readonly GCS_MIN_EXPIRATION_TIME = 10;

  static readonly HEADER_MAX_AGE = "max-age";
  static readonly VALUE_MAX_AGE_MAXIMUM = 3600;
  static readonly VALUE_MAX_AGE_MINIMUM = 0;

  static readonly HEADER_CACHE_CONTROL = "Cache-Control";
  static readonly VALUE_PUBLIC = "public";
  static readonly VALUE_NO_CACHE = "no-cache";
  static readonly CONTENT_DISPOSITION = "Content-Disposition";

  static readonly VALUE_APPLICATION_PDF = "application/pdf";
  static readonly VALUE_APPLICATION_JSON = "application/json";
  static readonly VALUE_APPLICATION_URL_ENCODED =
    "application/x-www-form-urlencoded";

  static readonly GLOBAL_HEADERS = {
    [this.HEADER_CONTENT_TYPE]: this.VALUE_APPLICATION_JSON,
  };

  static readonly QUERY_PARAM_PAGE = "page";
  static readonly QUERY_PARAM_SIZE = "size";
  static readonly QUERY_PARAM_NAME = "name";
  static readonly QUERY_PARAM_SORT = "sort";
  static readonly QUERY_PARAM_FILTERS = "filters";

  static readonly GCP_FILES = "file";
  static readonly GCP_FOLDERS = "folder";

  static readonly SOLUTION_BANNER_IMG = "solution.png";
  static readonly SOLUTION_BANNER_ICON = "solution.ico";
  static readonly ADMIN_SPLASH_IMG = "splash.png";
  static readonly ADMIN_THEME_PACK = "theme.json";
  static readonly TEMPLATE_FILE = "template.json";

  static readonly DEFAULT_DATE_FORMAT = "MMMM DD, YYYY h:mm A";
  static readonly MOBILE_DATA_FORMAT = "MMM DD YYYY";

  static readonly ZENDESK_AUTHORIZATION_URI =
    "https://%subdomain.zendesk.com/oauth/authorizations/new";

  static readonly BI_CONTACT_PAGE_URL="https://brightinsight.com/contact-us";

  static readonly ASSET_MANAGEMENT_SERVICE = "asset-management-service";
  static readonly BASE_STORAGE_URL = `https://storage.googleapis.com/${environment.ENV_TENANT_NAME}-${this.ASSET_MANAGEMENT_SERVICE}/assets`;

  static readonly DEFAULT_PRIVACY_URL =
    "https://brightinsight.com/privacy-policy";
  static readonly ASSETS_GCP_PATH = `assets/${environment.ENV_SOLUTION_NAME}/`;
  static readonly BASE_STORAGE_URL_TRANSLATION_SUFFIX = `${environment.ENV_SOLUTION_NAME}/i18n/languages`;
  static readonly BASE_STORAGE_URL_RULES_SUFFIX = `${environment.ENV_SOLUTION_NAME}/i18n/rules`;
  static readonly BASE_STORAGE_URL_DISCLAIMER_SUFFIX = `${environment.ENV_SOLUTION_NAME}/i18n/disclaimer`;
  static readonly BASE_STORAGE_URL_ADVERSE_SUFFIX = `${environment.ENV_SOLUTION_NAME}/i18n/adverse-event`;
  static readonly ASSETS_LOCALISATION_GCP_PATH = `assets/${environment.ENV_SOLUTION_NAME}/i18n/languages/`;
  static readonly DATA_REQUEST_APP_CONFIG_FILE_NAME = `config.json`;
  static readonly DATA_REQUEST_APP_CONFIG_PATH = `${AppConstants.ASSETS_GCP_PATH}config.json`;
  static readonly DATA_REQUEST_APP_CONFIG_FULL_PATH = `${AppConstants.BASE_STORAGE_URL}/${environment.ENV_SOLUTION_NAME}/config.json`;
  static readonly DATA_REQUEST_APP_TEMPLATE_FULL_PATH  = `${AppConstants.BASE_STORAGE_URL}/${environment.ENV_SOLUTION_NAME}/${this.TEMPLATE_FILE}`;
  static readonly LOCALISATION_NAMESPACE_TRANSLATION = "translation";
  static readonly LOCALISATION_NAMESPACE_RULES = "rules";
  static readonly LOCALISATION_NAMESPACE_DISCLAIMER = "disclaimer";
  static readonly LOCALISATION_NAMESPACE_ADVERSE = "adverse";
  static readonly ASSETS_LOCALISATION_FILE_PREFIX = `translation_`;
  static readonly ASSETS_LOCALISATION_RULES_GCP_PATH = `assets/${environment.ENV_SOLUTION_NAME}/i18n/rules/`;
  static readonly ASSETS_LOCALISATION_DISCLAIMER_GCP_PATH = `assets/${environment.ENV_SOLUTION_NAME}/i18n/disclaimer/`;
  static readonly ASSETS_LOCALISATION_ADVERSE_GCP_PATH = `assets/${environment.ENV_SOLUTION_NAME}/i18n/adverse-event/`;
  static readonly ASSETS_LOCALISATION_RULES_FILE_PREFIX = `rules_`;
  static readonly ASSETS_LOCALISATION_DISCLAIMER_FILE_PREFIX = `disclaimer_`;
  static readonly ASSETS_LOCALISATION_ADVERSE_FILE_PREFIX = `adverse_`;
  static readonly ASSETS_LOCALISATION_DEFAULT_LANGUAGE = "en";
  static readonly LOGO_ICON_URL = `${AppConstants.BASE_STORAGE_URL}/${environment.ENV_SOLUTION_NAME}/${this.SOLUTION_BANNER_ICON}`;
  static readonly LOGO_SOLUTION_URL = `${AppConstants.BASE_STORAGE_URL}/${environment.ENV_SOLUTION_NAME}/${this.SOLUTION_BANNER_IMG}`;
  static readonly LOGO_SPLASH_URL = `${AppConstants.BASE_STORAGE_URL}/${environment.ENV_SOLUTION_NAME}/${this.ADMIN_SPLASH_IMG}`;
  static readonly THEME_URL = `${AppConstants.BASE_STORAGE_URL}/${environment.ENV_SOLUTION_NAME}/${this.ADMIN_THEME_PACK}`;


  static readonly USER_LOCKED_OUT_MSG = "User Locked Out.";
  static readonly MAX_LENGTH_IMPORT_DESCRIPTION = 4096;

  static readonly ZENDESK_SYSTEM_FIELDS = ["subject", "description", "assignee"];

  static readonly VALUE_TEXT_PLAIN = "text/plain";

  static readonly ZENDESK_FIELDS_MAPPING = {
    "Username": "",
    Type: "",
    "Subject Name": "",
    "Recification Message": "",
    "Restriction Type": "",
    "Additional Message": "",
  };
  static readonly APIGEE_EU_GATEWAY_DOMAINS = {
    dev: "https://api-eu-dev.brightinsight.com",
    qa: "https://api-eu-qa.brightinsight.com",
    stage: "https://api-eu-staging.brightinsight.com",
    prod: "https://api-eu.brightinsight.com",
  };

  static readonly APIGEE_US_GATEWAY_DOMAINS = {
    dev: "https://api-us-dev.brightinsight.com",
    qa: "https://api-us-qa.brightinsight.com",
    stage: "https://api-us-staging.brightinsight.com",
    prod: "https://api-us.brightinsight.com",
  };

  static readonly DISABLED_ROLES_CUSTOMIZATION = ["Patient"];
  static readonly ENABLED_ROLES_CUSTOMIZATION = ["IT_ADMIN"];

  static SUPPORTED_ADVERSE_COUNTRIES = ["us", "ar", "cl", "ca", "mx", "ja"];

  static readonly LOCAL_STORAGE_LOCALE_KEY = "i18nextLng";
  static readonly LOCAL_STORAGE_COUNTRY_KEY = "i18nextCountry";
}
